export enum Garantia {
  N_APLICAVEL = 'N_APLICAVEL',
  SEM_GARANTIA = 'SEM_GARANTIA',
  SETE_DIAS = 'SETE_DIAS',
  TRINTA_DIAS = 'TRINTA_DIAS',
  NOVENTA_DIAS = 'NOVENTA_DIAS',
  SEIS_MESES = 'SEIS_MESES',
  UM_ANO = 'UM_ANO',
  UM_ANO_APPLE = 'UM_ANO_APPLE',
  GARANTIA_APPLE = 'GARANTIA_APPLE'
  }
  